// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .DocumentVerification-root-ELop1 {
 	padding-left: 20px;
 	padding-right: 20px;
 }

 .DocumentVerification-container-hoqb4 {
 	margin: 0 auto;
 	padding-top: 30px;
 	max-width: var(--max-content-width);
 }

 .DocumentVerification-infoTitle-Ob8bl {
 	color: var(--common-text-color);
 	font-size: 24px;
 	margin-bottom: 24px;
 	margin-top: 5px;
 }`, "",{"version":3,"sources":["webpack://./src/routes/documentVerification/DocumentVerification.css"],"names":[],"mappings":"CAAC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,iBAAiB;EACjB,mCAAmC;CACpC;;CAEA;EACC,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,eAAe;CAChB","sourcesContent":[" .root {\n \tpadding-left: 20px;\n \tpadding-right: 20px;\n }\n\n .container {\n \tmargin: 0 auto;\n \tpadding-top: 30px;\n \tmax-width: var(--max-content-width);\n }\n\n .infoTitle {\n \tcolor: var(--common-text-color);\n \tfont-size: 24px;\n \tmargin-bottom: 24px;\n \tmargin-top: 5px;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DocumentVerification-root-ELop1`,
	"container": `DocumentVerification-container-hoqb4`,
	"infoTitle": `DocumentVerification-infoTitle-Ob8bl`
};
module.exports = ___CSS_LOADER_EXPORT___;
